import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '@shared/services/registration.service';

@Component({
    selector: 'save-and-continue',
    templateUrl: './save-and-continue.component.html',
    styleUrls: ['./save-and-continue.component.scss']
})

export class SaveAndContinueComponent implements OnInit {
    emailRecipient: string = null;
    loading = true;

    constructor(
        private readonly registrationService: RegistrationService
    ){}

    ngOnInit(): void {
        this.registrationService.getApplicant().then(applicant => {
            this.emailRecipient = applicant.email;
            this.loading = false;
        });
    }
}
